import React from "react";
import { Outlet } from "react-router-dom";

import WebHeader from "../Header";
import WebFooter from "../Footer";
import GlobalBubbles from "../GlobalBubbles";
import ScrollToTopButton from "../ScrollToTopButton";

const MainLayout = () => {
  return (
    <>
      {/* Background */}
      <GlobalBubbles />

      {/* Header */}
      <WebHeader />

      {/* Page Content */}
      <main className="main-content">
        <div className="inner-div">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <WebFooter />

      {/* Scroll To Top */}
      <ScrollToTopButton />
    </>
  );
};

export default MainLayout;
